import accessibleAutocomplete from 'accessible-autocomplete';
import { debounce } from 'elements/utils';
import $ from 'jquery';
$.fn.geoGouvAutocompleteInput = function (options) {
  var $el = $(this);
  var id = options.id || $el.attr('data-geo-gouv-autocomplete-input');
  var updateLocation = function updateLocation(infos) {
    if (!infos) {
      $el.trigger('geo-gouv-result', null);
    } else {
      console.log(infos);
      $el.trigger('geo-gouv-result', infos);
    }
  };
  var defaultValue = options.defaultValue || null;
  accessibleAutocomplete({
    element: $el[0],
    id: id,
    confirmOnBlur: false,
    showNoOptionsFound: false,
    minLength: 3,
    defaultValue: defaultValue ? defaultValue.name : '',
    templates: {
      inputValue: function inputValue(result) {
        if (defaultValue) {
          result = defaultValue;
        }
        if (result && result.name && result.citycode) {
          return result.name + ' ( ' + result.citycode + ' )';
        }
      },
      suggestion: function suggestion(result) {
        if (defaultValue) {
          result = defaultValue;
        }
        return result && '<strong>' + result.name + '</strong>' + ' ( code INSEE de la commune ' + result.citycode + ')';
      }
    },
    onConfirm: function onConfirm(confirm) {
      if (defaultValue) {
        confirm = defaultValue;
      }
      if (confirm && confirm.name && confirm.citycode) {
        updateLocation(confirm);
      } else {
        updateLocation(null);
      }
    },
    source: debounce(function (query, syncResults) {
      defaultValue = null;
      $.ajax({
        url: 'https://api-adresse.data.gouv.fr/search/?q=' + query + '&type=municipality&autocomplete=1&limit=25',
        success: function success(response) {
          if (response.length === 0) {
            updateLocation(null);
          }
          if (response && response.features) {
            var out = [];
            for (var i in response.features) {
              var p = response.features[i].properties;
              if (p) {
                out.push(p);
              }
            }
            if (out.length > 0) {
              return syncResults(out);
            }
          }
          updateLocation(null);
        },
        error: function error(_error) {
          updateLocation(null);
        }
      });
    }, 500)
  });
  return this;
};